/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAlert } from '../../../Common/hooks';
import { getTaskFilters } from '../../selectors';
import { getTaskReports } from '../../services';
import { taskError } from '../../constants';

const useTaskReport = () => {
  const filters = useSelector(getTaskFilters);
  const { showAlert } = useAlert();
  const [taskReports, setTaskReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFilterChange = async () => {
    if (filters.aggregatorID && filters.payerID) {
      setIsLoading(true);
      const { taskList, status } = await getTaskReports(filters);
      if (status === 404) {
        showAlert({ color: 'error', icon: 'exclamation', message: taskError });
      }

      setTaskReports(taskList);
      setIsLoading(false);
    } else {
      setTaskReports([]);
    }
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters]);

  return {
    taskReports,
    isLoading,
  };
};

export default useTaskReport;
